<dx-data-grid id="grid"
              [allowColumnReordering]="true"
              [columnAutoWidth]="true"
              [dataSource]="investmentRequestDataSource"
              [repaintChangesOnly]="true"
              [wordWrapEnabled]="true"
              dateSerializationFormat="yyyy-MM-ddTHH:mm:ss"
              (onRowDblClick)="onRowDblClick($event)"
              (onRowPrepared)="onRowPrepared($event)"
              (onSelectionChanged)="selectedChanged($event)">
  <dxo-data-grid-selection mode="single"></dxo-data-grid-selection>
  <dxo-data-grid-grouping [autoExpandAll]="true"></dxo-data-grid-grouping>
  <dxo-data-grid-header-filter [visible]="true">
    <dxo-data-grid-search [enabled]="true"></dxo-data-grid-search>
  </dxo-data-grid-header-filter>
  <dxo-data-grid-group-panel [visible]="true"></dxo-data-grid-group-panel>
  <dxo-data-grid-filter-row [visible]="false"></dxo-data-grid-filter-row>
  <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
  <dxo-data-grid-editing [allowUpdating]="false"
               [allowAdding]="false"
               [allowDeleting]="true"
               mode="row">
  </dxo-data-grid-editing>
  <dxi-data-grid-column dataField="investmentRequestStateId"
              caption="Stato"
              [groupIndex]="1"
              groupCellTemplate="informatoreGroupCellTemplate">
    <dxo-data-grid-lookup [dataSource]="investmentRequestStatesDataSource"
                valueExpr="investmentRequestStateId"
                displayExpr="descrizione">
    </dxo-data-grid-lookup>
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="informatoreId"
              caption="Informatore"
              [groupIndex]="isAreaManager ? 2 : -1"
              calculateGroupValue="informatore"
              groupCellTemplate="informatoreGroupCellTemplate"
              [visible]="isAreaManager || isAdministrator">
    <dxo-data-grid-lookup [dataSource]="informatoriDataSource"
                valueExpr="userId"
                displayExpr="nome">
    </dxo-data-grid-lookup>
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="investmentRequestTypeId"
              caption="Tipo. Inv">
    <dxo-data-grid-lookup [dataSource]="investmentRequestTypesDataSource"
                valueExpr="investmentRequestTypeId"
                displayExpr="descrizione">
    </dxo-data-grid-lookup>
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="note"
              dataType="string"
              caption="Note"
              [hidingPriority]="4">
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="investmentBudgetTypeId"
              caption="Tipo Budget"
              [hidingPriority]="0">
    <dxo-data-grid-lookup [dataSource]="investmentBudgetTypesDataSource"
                valueExpr="investmentBudgetTypeId"
                displayExpr="descrizione">
    </dxo-data-grid-lookup>
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="importo"
              caption="Importo">
    <dxo-data-grid-format type="fixedPoint" [precision]="2"></dxo-data-grid-format>
  </dxi-data-grid-column>
  <dxo-data-grid-summary>
    <dxi-data-grid-group-item column="importo"
                    summaryType="sum"
                    [alignByColumn]="true"
                    [showInGroupFooter]="false"
                    [customizeText]="customizeTotaleImporto">
    </dxi-data-grid-group-item>
  </dxo-data-grid-summary>

  <div *dxTemplate="let data of 'informatoreGroupCellTemplate'">
    <div>{{data.text}}</div>
  </div>
</dx-data-grid>
<dx-speed-dial-action icon="add"
                      label="Aggiungi"
                      [index]="1"
                      (onClick)="addRow()">
</dx-speed-dial-action>
<dx-speed-dial-action icon="trash"
                      label="Cancella"
                      [index]="2"
                      [visible]="selectedRowIndex !== -1 && modificabile"
                      (onClick)="deleteRow()">
</dx-speed-dial-action>
<dx-speed-dial-action icon="edit"
                      label="Modifica"
                      [index]="3"
                      [visible]="selectedRowIndex !== -1 && modificabile"
                      (onClick)="editRow()">
</dx-speed-dial-action>
